import { Link } from "react-router-dom";
import img13 from "../Images/up-right-arrow.png";
import { useState } from "react";
import emailjs from "emailjs-com";

const Footer = ({ apidata }) => {
  const [formmessage, setFormMessage] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    country: "United States",
    phone: "",
    message: "",
  });
  const maxLen = 30;
  const phoneNumberlength = 15;
  const messageLength = 200;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setFormData({
      name: "",
      email: "",
      country: "United States",
      phone: "",
      message: "",
    });

    emailjs.sendForm(process.env.REACT_APP_ServiceID, process.env.REACT_APP_TemplateID, e.target, process.env.REACT_APP_ApiKey).then(
      (result) => {
        setFormMessage("Thank you for contacting us!");
      },
      (error) => {
        alert("Failed to send message.");
        setFormMessage("Failed to send message.");
        console.error(error.text);
      }
    );

    e.target.reset();
  };

  return (
    <>
      <section className="footer-section" id="footer">
        <div className="container">
          <div className="row">
            <form className="col-lg-12" onSubmit={handleSubmit}>
              <p className="contact-footer">{apidata?.SectionSix?.heading}</p>
              <ul className="footer-ul-1">
                <li>
                  <label htmlFor="name" className="footer-label">
                    {apidata?.SectionSix?.titleOne}
                  </label>
                  <input type="text" maxLength={maxLen} id="name" name="name" className="footer-input wid-1" placeholder="Name" onChange={handleInputChange} required />
                  <span
                    style={{
                      marginLeft: "10px",
                      fontSize: "12px",
                      color: formData.name?.length === maxLen ? "red" : "gray",
                    }}
                  >
                    {formData.name?.length} / {maxLen}
                  </span>
                </li>
                <li>
                  <label htmlFor="email" className="footer-label">
                    {apidata?.SectionSix?.titleTwo}
                  </label>
                  <input
                  
                    maxLength={maxLen}
                    type="email"
                    id="email"
                    name="email"
                    className="footer-input wid-2"
                    placeholder="youremail@mail.com"
                    onChange={handleInputChange}
                    required
                  />
                  <span
                    style={{
                      marginLeft: "10px",
                      fontSize: "12px",
                      color: formData.email?.length === maxLen ? "red" : "gray",
                    }}
                  >
                    {formData.email?.length} / {maxLen}
                  </span>
                </li>
                <li>
                  <label htmlFor="country" className="footer-label">
                    {apidata?.SectionSix?.titleThree}
                  </label>

                  <select
                    className="wpcf7-form-control wpcf7-select wpcf7-validates-as-required footer-input wid-3"
                    id="country"
                    name="country"
                    value={formData.country}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="United States">United States</option>
                    <option value="Afghanistan">Afghanistan</option>
                    <option value="Albania">Albania</option>
                    <option value="Algeria">Algeria</option>
                    <option value="Andorra">Andorra</option>
                    <option value="Angola">Angola</option>
                    <option value="Antigua and Barbuda">Antigua and Barbuda</option>
                    <option value="Argentina">Argentina</option>
                    <option value="Armenia">Armenia</option>
                    <option value="Australia">Australia</option>
                    <option value="Austria">Austria</option>
                    <option value="Azerbaijan">Azerbaijan</option>
                    <option value="Bahamas">Bahamas</option>
                    <option value="Bahrain">Bahrain</option>
                    <option value="Bangladesh">Bangladesh</option>
                    <option value="Barbados">Barbados</option>
                    <option value="Belarus">Belarus</option>
                    <option value="Belgium">Belgium</option>
                    <option value="Belize">Belize</option>
                    <option value="Benin">Benin</option>
                    <option value="Bhutan">Bhutan</option>
                    <option value="Bolivia">Bolivia</option>
                    <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
                    <option value="Botswana">Botswana</option>
                    <option value="Brazil">Brazil</option>
                    <option value="Brunei">Brunei</option>
                    <option value="Bulgaria">Bulgaria</option>
                    <option value="Burkina Faso">Burkina Faso</option>
                    <option value="Burundi">Burundi</option>
                    <option value="Cabo Verde">Cabo Verde</option>
                    <option value="Cambodia">Cambodia</option>
                    <option value="Cameroon">Cameroon</option>
                    <option value="Canada">Canada</option>
                    <option value="Central African Republic">Central African Republic</option>
                    <option value="Chad">Chad</option>
                    <option value="Chile">Chile</option>
                    <option value="China">China</option>
                    <option value="Colombia">Colombia</option>
                    <option value="Comoros">Comoros</option>
                    <option value="Congo">Congo</option>
                    <option value="Costa Rica">Costa Rica</option>
                    <option value="Croatia">Croatia</option>
                    <option value="Cuba">Cuba</option>
                    <option value="Cyprus">Cyprus</option>
                    <option value="Czech Republic">Czech Republic</option>
                    <option value="Denmark">Denmark</option>
                    <option value="Djibouti">Djibouti</option>
                    <option value="Dominica">Dominica</option>
                    <option value="Dominican Republic">Dominican Republic</option>
                    <option value="Ecuador">Ecuador</option>
                    <option value="Egypt">Egypt</option>
                    <option value="El Salvador">El Salvador</option>
                    <option value="Equatorial Guinea">Equatorial Guinea</option>
                    <option value="Eritrea">Eritrea</option>
                    <option value="Estonia">Estonia</option>
                    <option value="Eswatini">Eswatini</option>
                    <option value="Ethiopia">Ethiopia</option>
                    <option value="Fiji">Fiji</option>
                    <option value="Finland">Finland</option>
                    <option value="France">France</option>
                    <option value="Gabon">Gabon</option>
                    <option value="Gambia">Gambia</option>
                    <option value="Georgia">Georgia</option>
                    <option value="Germany">Germany</option>
                    <option value="Ghana">Ghana</option>
                    <option value="Greece">Greece</option>
                    <option value="Grenada">Grenada</option>
                    <option value="Guatemala">Guatemala</option>
                    <option value="Guinea">Guinea</option>
                    <option value="Guinea-Bissau">Guinea-Bissau</option>
                    <option value="Guyana">Guyana</option>
                    <option value="Haiti">Haiti</option>
                    <option value="Honduras">Honduras</option>
                    <option value="Hungary">Hungary</option>
                    <option value="Iceland">Iceland</option>
                    <option value="India">India</option>
                    <option value="Indonesia">Indonesia</option>
                    <option value="Iran">Iran</option>
                    <option value="Iraq">Iraq</option>
                    <option value="Ireland">Ireland</option>
                    <option value="Israel">Israel</option>
                    <option value="Italy">Italy</option>
                    <option value="Jamaica">Jamaica</option>
                    <option value="Japan">Japan</option>
                    <option value="Jordan">Jordan</option>
                    <option value="Kazakhstan">Kazakhstan</option>
                    <option value="Kenya">Kenya</option>
                    <option value="Kiribati">Kiribati</option>
                    <option value="Korea (North)">Korea (North)</option>
                    <option value="Korea (South)">Korea (South)</option>
                    <option value="Kuwait">Kuwait</option>
                    <option value="Kyrgyzstan">Kyrgyzstan</option>
                    <option value="Laos">Laos</option>
                    <option value="Latvia">Latvia</option>
                    <option value="Lebanon">Lebanon</option>
                    <option value="Lesotho">Lesotho</option>
                    <option value="Liberia">Liberia</option>
                    <option value="Libya">Libya</option>
                    <option value="Liechtenstein">Liechtenstein</option>
                    <option value="Lithuania">Lithuania</option>
                    <option value="Luxembourg">Luxembourg</option>
                    <option value="Madagascar">Madagascar</option>
                    <option value="Malawi">Malawi</option>
                    <option value="Malaysia">Malaysia</option>
                    <option value="Maldives">Maldives</option>
                    <option value="Mali">Mali</option>
                    <option value="Malta">Malta</option>
                    <option value="Marshall Islands">Marshall Islands</option>
                    <option value="Mauritania">Mauritania</option>
                    <option value="Mauritius">Mauritius</option>
                    <option value="Mexico">Mexico</option>
                    <option value="Micronesia">Micronesia</option>
                    <option value="Moldova">Moldova</option>
                    <option value="Monaco">Monaco</option>
                    <option value="Mongolia">Mongolia</option>
                    <option value="Montenegro">Montenegro</option>
                    <option value="Morocco">Morocco</option>
                    <option value="Mozambique">Mozambique</option>
                    <option value="Myanmar">Myanmar</option>
                    <option value="Namibia">Namibia</option>
                    <option value="Nauru">Nauru</option>
                    <option value="Nepal">Nepal</option>
                    <option value="Netherlands">Netherlands</option>
                    <option value="New Zealand">New Zealand</option>
                    <option value="Nicaragua">Nicaragua</option>
                    <option value="Niger">Niger</option>
                    <option value="Nigeria">Nigeria</option>
                    <option value="North Macedonia">North Macedonia</option>
                    <option value="Norway">Norway</option>
                    <option value="Oman">Oman</option>
                    <option value="Pakistan">Pakistan</option>
                    <option value="Palau">Palau</option>
                    <option value="Palestine">Palestine</option>
                    <option value="Panama">Panama</option>
                    <option value="Papua New Guinea">Papua New Guinea</option>
                    <option value="Paraguay">Paraguay</option>
                    <option value="Peru">Peru</option>
                    <option value="Philippines">Philippines</option>
                    <option value="Poland">Poland</option>
                    <option value="Portugal">Portugal</option>
                    <option value="Qatar">Qatar</option>
                    <option value="Romania">Romania</option>
                    <option value="Russia">Russia</option>
                    <option value="Rwanda">Rwanda</option>
                    <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
                    <option value="Saint Lucia">Saint Lucia</option>
                    <option value="Saint Vincent and the Grenadines">Saint Vincent and the Grenadines</option>
                    <option value="Samoa">Samoa</option>
                    <option value="San Marino">San Marino</option>
                    <option value="Sao Tome and Principe">Sao Tome and Principe</option>
                    <option value="Saudi Arabia">Saudi Arabia</option>
                    <option value="Senegal">Senegal</option>
                    <option value="Serbia">Serbia</option>
                    <option value="Seychelles">Seychelles</option>
                    <option value="Sierra Leone">Sierra Leone</option>
                    <option value="Singapore">Singapore</option>
                    <option value="Slovakia">Slovakia</option>
                    <option value="Slovenia">Slovenia</option>
                    <option value="Solomon Islands">Solomon Islands</option>
                    <option value="Somalia">Somalia</option>
                    <option value="South Africa">South Africa</option>
                    <option value="South Sudan">South Sudan</option>
                    <option value="Spain">Spain</option>
                    <option value="Sri Lanka">Sri Lanka</option>
                    <option value="Sudan">Sudan</option>
                    <option value="Suriname">Suriname</option>
                    <option value="Sweden">Sweden</option>
                    <option value="Switzerland">Switzerland</option>
                    <option value="Syria">Syria</option>
                    <option value="Taiwan">Taiwan</option>
                    <option value="Tajikistan">Tajikistan</option>
                    <option value="Tanzania">Tanzania</option>
                    <option value="Thailand">Thailand</option>
                    <option value="Timor-Leste">Timor-Leste</option>
                    <option value="Togo">Togo</option>
                    <option value="Tonga">Tonga</option>
                    <option value="Trinidad and Tobago">Trinidad and Tobago</option>
                    <option value="Tunisia">Tunisia</option>
                    <option value="Turkey">Turkey</option>
                    <option value="Turkmenistan">Turkmenistan</option>
                    <option value="Tuvalu">Tuvalu</option>
                    <option value="Uganda">Uganda</option>
                    <option value="Ukraine">Ukraine</option>
                    <option value="United Arab Emirates">United Arab Emirates</option>
                    <option value="United Kingdom">United Kingdom</option>
                    <option value="Uruguay">Uruguay</option>
                    <option value="Uzbekistan">Uzbekistan</option>
                    <option value="Vanuatu">Vanuatu</option>
                    <option value="Vatican City">Vatican City</option>
                    <option value="Venezuela">Venezuela</option>
                    <option value="Vietnam">Vietnam</option>
                    <option value="Yemen">Yemen</option>
                    <option value="Zambia">Zambia</option>
                    <option value="Zimbabwe">Zimbabwe</option>
                  </select>
                </li>

                <li>
                  <label htmlFor="phone" className="footer-label">
                    {apidata?.SectionSix?.titleFour}
                  </label>
                  <input
                    type="tel"
                    maxLength={phoneNumberlength}
                    id="phone"
                    name="phone"
                    className="footer-input wid-4"
                    placeholder="000 0000"
                    onChange={handleInputChange}
                    required
                  />
                  <span
                    style={{
                      marginLeft: "10px",
                      fontSize: "12px",
                      color: formData.phone?.length === phoneNumberlength ? "red" : "gray",
                    }}
                  >
                    {formData.phone?.length} / {phoneNumberlength}
                  </span>
                </li>
              </ul>
              <ul className="footer-ul-2">
                <li>
                  <input type="text" maxLength={messageLength} name="message" className="footer-input wid-5" placeholder="Tell us more..." onChange={handleInputChange} required />
                  <span
                    style={{
                      marginLeft: "10px",
                      fontSize: "12px",
                      color: formData.message?.length === messageLength ? "red" : "gray",
                    }}
                  >
                    {formData.message?.length} / {messageLength}
                  </span>
                </li>
                <li>
                  <button className="zoom">
                    {apidata?.SectionSix?.button}

                    <img src={img13} alt="Arrow Icon" />
                  </button>
                </li>
              </ul>
              <div className="footer-last">
                <a href="mailto:info@areax.ai" className="info-a">
                  info@areax.ai
                </a>
                <ul className="footer-ul-3">
                  <li>
                    <a href="#">{apidata?.SectionSix?.linkOne}</a>
                  </li>
                  <li>
                    <a href="#">{apidata?.SectionSix?.linkTwo}</a>
                  </li>
                  <li>
                    <a href="#">{apidata?.SectionSix?.linkThree}</a>
                  </li>
                </ul>
              </div>
            </form>
          </div>
          {formmessage && (
            <p className="my-4" style={{ border: "3px solid #46b450", width: "100%", padding: "8px" }}>
              {formmessage}
            </p>
          )}
        </div>

        <div className="height-54">
          <ul id="menu-bottom-line" class="footer-ul-3">
            <li id="menu-item-156" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-156">
              <Link to="/terms-conditions">Terms &amp; Conditions</Link>
            </li>
            <li id="menu-item-157" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-157">
              <Link to="/privacy-policy">Privacy Policy</Link>
            </li>
          </ul>{" "}
        </div>
      </section>
    </>
  );
};

export default Footer;
